import { SelectOption } from 'client/ui/form/input/SelectInput';
import { SDIChargeabilityType } from './VATSummaryTypes';

export const SDIChargeabilityOptions: SelectOption[] = [
  { value: SDIChargeabilityType.Immediate, label: 'Immediata' },
  { value: SDIChargeabilityType.Deferred, label: 'Differita' },
  { value: SDIChargeabilityType.Split, label: 'Scissione dei Pagamenti' }
];
